import { Box, Button, Card, Typography } from '@mui/material'

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import WTypography from '../../../../Components/whiteTypography'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark'
import QuestionAnswerFormTemps from './QuestionAnswerForm'
import { isEmpty } from 'lodash'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { useSelector } from 'react-redux'
import LockIcon from '@mui/icons-material/Lock'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function ConseilsCard({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  let w_tprofile = sessionStorage.getItem('w-tprofile')
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const siteUser = useSelector((store) => store.user)

  useEffect(() => {
    if (w_tprofile) {
      setOpen(true)
    }
  }, [])
  useEffect(() => {}, [oldData])

  // LAP-733 (GE022) — override backend "Api OpenAi"/"OpenAI"/"ChatGPT" signature
  // with the unified "Life Agent" label.
  const displaySource = (() => {
    const src = oldData?.source
    if (!src) return src
    if (/(open\s*ai|openai|chat\s*gpt|chatgpt|gpt-?\d)/i.test(String(src))) {
      return t('syntheseTemps.lifeAgentSignature')
    }
    return src
  })()

  if (!siteUser?.user?.has_subscription) {
    return (
      <Card className="dashboard_card__root1">
        <Box
          sx={{
            padding: 4,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h5"
            component="h1"
            sx={{
              color: '#e0e0e0',
              fontWeight: 600,
              marginBottom: 4,
            }}
          >
            {t('syntheseTemps.adviceTitle')}
          </Typography>

          <LockIcon
            sx={{
              fontSize: 80,
              color: '#5a5a6b',
              marginBottom: 4,
            }}
          />

          <Typography
            variant="h6"
            sx={{
              color: '#e0e0e0',
              marginBottom: 6,
              lineHeight: 1.5,
            }}
          >
            {t('syntheseTemps.adviceLockedSubtitle')}
          </Typography>

          <Button
            variant="contained"
            className="no-drag"
            sx={{
              width: '100%',
              backgroundColor: '#38384d',
              color: '#e0e0e0',
              padding: '12px 0',
              fontSize: '1rem',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#4a4a5f',
              },
            }}
            onClick={() => {
              navigate('/subscription')
            }}
          >
            {t('syntheseTemps.goToPremium')}
          </Button>
        </Box>
      </Card>
    )
  }

  return (
    <Card className="dashboard_card__root1">
      <>
        <Box className="dashboard_card__header1">
          <WTypography component={'span'} variant="h6">
            {t('syntheseTemps.adviceCardTitle')}
          </WTypography>
        </Box>
        {!isEmpty(oldData) && (
          <Box className="dashboard_card__header1">
            <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
              {t('syntheseTemps.adviceCardSubtitle')}
            </WTypography>
          </Box>
        )}

        <Box mt={7} minWidth={3} mb={6} height={'100%'}>
          {isEmpty(oldData) ? (
            <Box
              className="no-drag"
              height={'70%'}
              justifyContent={'center'}
              color={'white'}
              display={'flex'}
              flexDirection={'column'}
              alignItems={'center'}
            >
              <QuestionAnswerFormTemps
                open={open}
                setOpen={setOpen}
                startIcon={
                  <Box
                    color={'#00295f'}
                    padding={5}
                    bgcolor={'white'}
                    borderRadius={'50%'}
                    mb={3}
                  >
                    <QuestionMarkIcon sx={{ fontSize: '55px' }} />
                  </Box>
                }
                updateReports={updateReports}
              />

              <Box padding={'0 20px'}>
                {t('syntheseTemps.timeProfileQuestionPrompt')}
              </Box>
            </Box>
          ) : (
            <>
              <Box
                height={'50%'}
                justifyContent={'center'}
                color={'white'}
                display={'flex'}
                flexDirection={'column'}
                fontSize={'20px'}
              >
                <Box textAlign={'center'} fontStyle={'italic'}>
                  {oldData?.content}
                </Box>
                <Box textAlign={'right'} mt={5}>
                  {displaySource /* LAP-733 (GE022) */}
                </Box>
              </Box>
              {oldData?.function && (
                <Box color={'white'} textAlign={'center'} mt={8} className="no-drag">
                  {oldData?.function}
                  <Box
                    sx={{ cursor: 'pointer' }}
                    component={'span'}
                    ml={2}
                    onClick={() => navigate(oldData.function_link)}
                  >
                    <KeyboardArrowRightIcon sx={{ bgcolor: '#438295', borderRadius: '50%' }} />
                  </Box>
                </Box>
              )}
            </>
          )}
        </Box>
        {!isEmpty(oldData) && (
          <Box mt={2} className="dashboard_card__filters1 no-drag">
            <Box>
              <QuestionAnswerFormTemps
                open={open}
                setOpen={setOpen}
                startIcon={
                  <Box
                    color={'#00295f'}
                    padding={'0 8px'}
                    bgcolor={'white'}
                    borderRadius={'50%'}
                    mb={1}
                    mr={2}
                  >
                    <FontAwesomeIcon icon={faInfo} />
                  </Box>
                }
                updateReports={updateReports}
              />
            </Box>
          </Box>
        )}
      </>
    </Card>
  )
}

export default ConseilsCard
